import { combineReducers } from "redux";

import { AuthData } from "./auth";
import { GetCustomerByIDData, GetListCustomerData } from "./customer";
import { GetListDocumentationData } from "./documentation";
import {
  DropdownBuildingTypesData,
  DropdownCustomersData,
  DropdownDistrictsData,
  DropdownStatusData,
  DropdownUsersData,
  DropdownVillagesData,
} from "./dropdown";
import { GetListScheduleData } from "./schedule";
import { GetListUsersData, GetUserByUsernameData } from "./user";

export const rootReducer = combineReducers({
  AuthData: AuthData,
  GetUserByUsernameData: GetUserByUsernameData,
  GetListUsersData: GetListUsersData,
  GetListCustomerData: GetListCustomerData,
  GetCustomerByIDData: GetCustomerByIDData,
  GetListScheduleData: GetListScheduleData,
  GetListDocumentationData: GetListDocumentationData,
  DropdownVillagesData: DropdownVillagesData,
  DropdownDistrictsData: DropdownDistrictsData,
  DropdownBuildingTypesData: DropdownBuildingTypesData,
  DropdownStatusData: DropdownStatusData,
  DropdownCustomersData: DropdownCustomersData,
  DropdownUsersData: DropdownUsersData,
});
